// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchResultsSkeleton-allCategorySkeletonList-r9tuQ {
    position: relative;
    z-index: 1;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    row-gap: 40px;
    -webkit-column-gap: 30px;
       -moz-column-gap: 30px;
            column-gap: 30px;
}

.SearchResultsSkeleton-allCategorySkeletonListItem-NJEUt {
    width: 100%;
    max-width: 155px;
    margin: 0 auto;
    text-align: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 18px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.SearchResultsSkeleton-allCategorySkeletonListItemImg-JJO8T {
    position: relative;
    width: 100%;
    max-width: 136px;
    height: 136px;
    border-radius: 0 var(--radius-2) 0 var(--radius-2);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    background-color: var(--skeleton-secondary-bg);
    margin: 0 auto;
}

.SearchResultsSkeleton-allCategorySkeletonListItemInfo-XyY3V {
    max-width: 100px;
    height: 28px;
    background-color: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}

@media (max-width: 1199px) {

    .SearchResultsSkeleton-allCategorySkeletonListItem11-LFzCH,
    .SearchResultsSkeleton-allCategorySkeletonListItem12-i_f_M,
    .SearchResultsSkeleton-allCategorySkeletonListItem13-GkUGI,
    .SearchResultsSkeleton-allCategorySkeletonListItem14-YYxWl {
        display: none;
    }
}

@media (max-width: 1199px) and (min-width: 1024px) {
    .SearchResultsSkeleton-allCategorySkeletonList-r9tuQ {
        grid-template-columns: repeat(5, 1fr);
    }
}

@media (max-width: 1023px) {

    .SearchResultsSkeleton-allCategorySkeletonListItem9-zYAzK,
    .SearchResultsSkeleton-allCategorySkeletonListItem10-Am3Q7 {
        display: none;
    }
}

@media (max-width: 1023px) and (min-width: 768px) {
    .SearchResultsSkeleton-allCategorySkeletonList-r9tuQ {
        grid-template-columns: repeat(4, 1fr);
    }
}

@media (max-width: 767px) {

    .SearchResultsSkeleton-allCategorySkeletonListItem7-rDK4v,
    .SearchResultsSkeleton-allCategorySkeletonListItem8-uiDOY {
        display: none;
    }

    .SearchResultsSkeleton-allCategorySkeletonList-r9tuQ {
        gap: 18px;
        grid-gap: 18px;
    }
}

@media (max-width: 767px) and (min-width: 576px) {
    .SearchResultsSkeleton-allCategorySkeletonList-r9tuQ {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 575px) {

    .SearchResultsSkeleton-allCategorySkeletonListItem5-CMtV_,
    .SearchResultsSkeleton-allCategorySkeletonListItem6-COznz {
        display: none;
    }
}

@media (max-width: 575px) and (min-width: 375px) {
    .SearchResultsSkeleton-allCategorySkeletonList-r9tuQ {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 374px) {
    .SearchResultsSkeleton-allCategorySkeletonList-r9tuQ {
        grid-template-columns: repeat(1, 1fr);
    }

    .SearchResultsSkeleton-allCategorySkeletonListItem4-WY2mz {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/Categories/SearchResultsSkeleton/SearchResultsSkeleton.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,qCAAqC;IACrC,aAAa;IACb,wBAAgB;OAAhB,qBAAgB;YAAhB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,SAAS;IACT,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kDAAkD;IAClD,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,8CAA8C;IAC9C,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,8CAA8C;IAC9C,8BAA8B;AAClC;;AAEA;;IAEI;;;;QAII,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;;IAEI;;QAEI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;;IAEI;;QAEI,aAAa;IACjB;;IAEA;QACI,SAAS;QACT,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;;IAEI;;QAEI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAGA;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".allCategorySkeletonList {\n    position: relative;\n    z-index: 1;\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    row-gap: 40px;\n    column-gap: 30px;\n}\n\n.allCategorySkeletonListItem {\n    width: 100%;\n    max-width: 155px;\n    margin: 0 auto;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n    align-items: center;\n}\n\n.allCategorySkeletonListItemImg {\n    position: relative;\n    width: 100%;\n    max-width: 136px;\n    height: 136px;\n    border-radius: 0 var(--radius-2) 0 var(--radius-2);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: var(--skeleton-secondary-bg);\n    margin: 0 auto;\n}\n\n.allCategorySkeletonListItemInfo {\n    max-width: 100px;\n    height: 28px;\n    background-color: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n@media (max-width: 1199px) {\n\n    .allCategorySkeletonListItem11,\n    .allCategorySkeletonListItem12,\n    .allCategorySkeletonListItem13,\n    .allCategorySkeletonListItem14 {\n        display: none;\n    }\n}\n\n@media (max-width: 1199px) and (min-width: 1024px) {\n    .allCategorySkeletonList {\n        grid-template-columns: repeat(5, 1fr);\n    }\n}\n\n@media (max-width: 1023px) {\n\n    .allCategorySkeletonListItem9,\n    .allCategorySkeletonListItem10 {\n        display: none;\n    }\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n    .allCategorySkeletonList {\n        grid-template-columns: repeat(4, 1fr);\n    }\n}\n\n@media (max-width: 767px) {\n\n    .allCategorySkeletonListItem7,\n    .allCategorySkeletonListItem8 {\n        display: none;\n    }\n\n    .allCategorySkeletonList {\n        gap: 18px;\n        grid-gap: 18px;\n    }\n}\n\n@media (max-width: 767px) and (min-width: 576px) {\n    .allCategorySkeletonList {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n\n@media (max-width: 575px) {\n\n    .allCategorySkeletonListItem5,\n    .allCategorySkeletonListItem6 {\n        display: none;\n    }\n}\n\n@media (max-width: 575px) and (min-width: 375px) {\n    .allCategorySkeletonList {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n\n@media (max-width: 374px) {\n    .allCategorySkeletonList {\n        grid-template-columns: repeat(1, 1fr);\n    }\n\n    .allCategorySkeletonListItem4 {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"allCategorySkeletonList": `SearchResultsSkeleton-allCategorySkeletonList-r9tuQ`,
	"allCategorySkeletonListItem": `SearchResultsSkeleton-allCategorySkeletonListItem-NJEUt`,
	"allCategorySkeletonListItemImg": `SearchResultsSkeleton-allCategorySkeletonListItemImg-JJO8T`,
	"allCategorySkeletonListItemInfo": `SearchResultsSkeleton-allCategorySkeletonListItemInfo-XyY3V`,
	"allCategorySkeletonListItem11": `SearchResultsSkeleton-allCategorySkeletonListItem11-LFzCH`,
	"allCategorySkeletonListItem12": `SearchResultsSkeleton-allCategorySkeletonListItem12-i_f_M`,
	"allCategorySkeletonListItem13": `SearchResultsSkeleton-allCategorySkeletonListItem13-GkUGI`,
	"allCategorySkeletonListItem14": `SearchResultsSkeleton-allCategorySkeletonListItem14-YYxWl`,
	"allCategorySkeletonListItem9": `SearchResultsSkeleton-allCategorySkeletonListItem9-zYAzK`,
	"allCategorySkeletonListItem10": `SearchResultsSkeleton-allCategorySkeletonListItem10-Am3Q7`,
	"allCategorySkeletonListItem7": `SearchResultsSkeleton-allCategorySkeletonListItem7-rDK4v`,
	"allCategorySkeletonListItem8": `SearchResultsSkeleton-allCategorySkeletonListItem8-uiDOY`,
	"allCategorySkeletonListItem5": `SearchResultsSkeleton-allCategorySkeletonListItem5-CMtV_`,
	"allCategorySkeletonListItem6": `SearchResultsSkeleton-allCategorySkeletonListItem6-COznz`,
	"allCategorySkeletonListItem4": `SearchResultsSkeleton-allCategorySkeletonListItem4-WY2mz`
};
module.exports = ___CSS_LOADER_EXPORT___;
